import { css } from 'react-strict-dom';

import Stack from './Stack';
import Text from './Text';

type Props = Readonly<{
  errors?: string[];
  style?: css.StyleXStyles;
}>;

export default function ErrorList({ errors, style }: Props) {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <Stack style={style} gap={0.5}>
      {errors.map((errorMessage, i) => (
        <Text key={i} typeface="body.small.regular" color="red">
          {errorMessage}
        </Text>
      ))}
    </Stack>
  );
}
